import { WT_AD_BLOCK_INITIALIZED } from '../constants';
import { EXP_AD_BLOCK_LIBRARY_RELEASE } from '@wetransfer/transfer/constant/experiments';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export * from './get-initial-state';

/**
 * @returns {boolean}
 */
export const isAdBlockingLibraryEnabled = (): boolean => {
  const isLibraryEnabled = getFullVariant(EXP_AD_BLOCK_LIBRARY_RELEASE.key, {
    payload: EXP_AD_BLOCK_LIBRARY_RELEASE.default,
  }).value;

  return isLibraryEnabled === 'target';
};

export const getAdBlockDetection = ():
  | undefined
  | { hasAdBlocker: boolean } => {
  return (window.AdTech as any)?.adBlockDetection;
};

export const emitAdBlockInitialized = (): void => {
  window.dispatchEvent(new Event(WT_AD_BLOCK_INITIALIZED));
};
